module.exports = __webpack_public_path__ + "static/img/clock.8943974.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clock.png
// module id = uZcP
// module chunks = 1